<template>
    <div id="app-spinner">
        <v-dialog v-model="dialog" ersistent width="200">
            <v-card color="#2accdd">
                <v-card-text>
                    <div align="center">
                        <img
                            :src="require('@/assets/img/launcher.png')"
                            class="my-3"
                            style="width: 25px"
                        />
                        <span class="font-weight-bold ml-2"
                            >Memproses Data</span
                        >
                    </div>
                    <v-progress-linear
                        indeterminate
                        color="#0b4e79"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- <div class="sl-loading">
      <v-progress-circular
        :width="3"
        :size="20"
        color="white"
        indeterminate
      ></v-progress-circular>
      <span class="ml-1">
        Memuat Data..
      </span>
    </div> -->
        <!-- <v-progress :width="2" :size="18" color="primary" indeterminate circular></v-progress> -->
        <!-- <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div
            class="modal-container"
            style="max-width: 25%; text-align: center"
          >
            <span id="spinner" class="fa fa-spinner"></span> &nbsp; Loadingss...
          </div>
        </div>
      </div>
    </transition> -->
    </div>
</template>

<style>
.sl-loading {
    margin-top: 18px;
    text-align: center;
    font-size: 18px;
    padding: 10px;
    width: 100%;
    background-color: #26a69a !important;
    color: #fff !important;
    border-radius: 5px;
}

#spinner {
    -webkit-animation: rotation 1s linear infinite;
    -moz-animation: rotation 1s linear infinite;
    animation: rotation 1s linear infinite;
}

@-moz-keyframes spin {
    100% {
        -moz-transform: rotate(360deg);
    }
}
@-webkit-keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
    }
}
@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>

<script>
export default {
    name: "app-spinner",
    data() {
        return {
            dialog: true,
        };
    },
};
</script>



// WEBPACK FOOTER //
// Spinner.vue?7296f57b